import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Alert, Tabs, Tab } from 'react-bootstrap';
import Form from '../form/Form';
import FieldGroup from '../field_group/FieldGroup';
import { cfpFieldGroups } from '../field_group/CFPFields';
import Thumbnail from '../thumbnail/Thumbnail';
import RelationDataTable from '../datatable/RelationDataTable';
import MaterialLayerPreviewer from '../material/MaterialLayerPreviewer';
import { COLUMN_STYLE, getColumnStyle } from '../datatable/util';
import { requiredValidator } from '../field_group/validators';
import { getErrorValue, toMilli } from '../../utils/utility';
import { searchTransparentMaterial } from '../../redux/material_transparent/material_actions';
import {
  addMaterialToComponent,
  removeMaterialFromComponent,
  listMaterialInComponent,
  clearMaterialOpaque,
} from '../../redux/component/component_material_actions';
import { listHeatDissipation } from '../../redux/references/envelop_actions';
export class ComponentTransparentDetail extends React.Component {
  constructor(props) {
    super(props);
    this.formRef = undefined;

    this.search = {
      pageSize: this.DEFAULT_PAGE_SIZE,
      page: null,
      sorted: null,
      filtered: null,
    };

    this.state = {
      isShowDeleteModal: false,
      materialToComponentArr: [],
      errorMessage : null,
      isMaterialRemoving: false,
    };

    const { t } = props;

    this.columns = [
      {
        Header: '',
        accessor: 'material.thumbnail',
        Cell: row => <Thumbnail img={row.value} />,
        ...getColumnStyle(COLUMN_STYLE.thumbnail),
      },
      {
        Header: () => <b>{t('name')}</b>,
        accessor: 'material.name',
        ...getColumnStyle(COLUMN_STYLE.text),
        entity: {
          list: (text, page) => searchTransparentMaterial(text, page)
            .then(payload => payload.data.map(item => ({ label: item.name, value: String(item.id),original:item}))),
          create: null,
        },
      },
      {
        Header: () => <b>{t('category')}</b>,
        accessor: 'material.is_public',
        Cell: row =>
          row.value ? (
            <span>
              <i className="fas fa-users" /> {t('public')}
            </span>
          ) : (
            <span>
              <i className="fas fa-user" /> {t('private')}
            </span>
          ),
        ...getColumnStyle(COLUMN_STYLE.category),
      },
      {  
        Header: () => (
          <b>
            {t('thickness')} ({t('unit_mm')})
          </b>
        ),
        accessor: 'thickness',
        ...getColumnStyle(COLUMN_STYLE.coefficient),
        width: 140,
      }
    ];
  }

  getComponentData() {
    return this.formRef.getFormData();
  }

  renderOption(item, prefix) {
    const { t } = this.props;
    return (
      <option key={prefix ? `${prefix}${item.id}` : item.id} value={item.id}>
        {t(String(item.name).toLowerCase())}
      </option>
    );
  }

  componentDidMount() {
    if (this.props.listHeatDissipation) {
      this.props.listHeatDissipation();
    }
  }

  renderBasicInfo() {
    const {
      name,
      heat_dissipation_id,
      description,
      SHGC,
      transmittance,
      image,
      cfp_value,
      cfp_unit,
    } = this.props.component;

    const { disabled, fieldErrors, errorMessage, t, ...otherAttr } = this.props;
    const customAttr = { disabled };
    return (
      <Form image={image} {...otherAttr} ref={ref => (this.formRef = ref)}>
        <FieldGroup
          id="component-transparent-name"
          field="name"
          type="text"
          label={t('name')}
          placeholder={t('transparent component name')}
          value={name}
          validators={[requiredValidator]}
          errorMessage={getErrorValue(fieldErrors, 'name')}
          {...customAttr}
        />
        <FieldGroup
          id="component-transparent-inner-surface"
          field="heat_dissipation_id"
          componentClass="select"
          label={t('inner surface')}
          value={heat_dissipation_id}
          defaultDirty={true}
          errorMessage={getErrorValue(fieldErrors, 'heat-dissipation')}
          {...customAttr}
          disabled={!!(this.props.heatDissipationListLoading || disabled)}
        >
          {this.props.heatDissipationList.map(item => ({
              name: item.heat_dissipation,
              id: item.id,
            }),
          ).map(item => this.renderOption(item, 'hdp'))}
        </FieldGroup>
        {cfpFieldGroups({ cfp_value, cfp_unit, disabled, fieldErrors, t })}
        <FieldGroup
          id="component-transparent-description"
          field="description"
          componentClass="textarea"
          label={t('description')}
          value={description}
          {...customAttr}
        />
        <FieldGroup
          id="component-transparent-shgc"
          field="SHGC"
          componentClass="input"
          readOnly={true}
          label={t('SHGC')}
          value={SHGC}
          {...customAttr}
        />
        <FieldGroup
          id="component-transparent-transmittance"
          field="transmittance"
          componentClass="input"
          readOnly={true}
          label={t('visible transmittance')}
          value={transmittance}
          {...customAttr}
        />
      </Form>
    );
  }

  updateSortFilter(filter, state, category) {
    if (state) {
      this.search.pageSize = state.pageSize;
      this.search.page = state.page;
      this.search.sorted = state.sorted;
    }
    this.search.filtered = filter;

    if(this.props.component.id){
      this.props.listMaterial(
        this.search.pageSize,
        this.search.page,
        this.search.sorted,
        this.search.filtered,
        {
          all: null,
          public: true,
          private: false,
        }[category],
      );
    }
    this.setState({ categoryOption: category });
  }
  renderMaterials() {
    const {
      component: { id: componentId },
      componentMaterials: materials,
      filteredCount,
      t
    } = this.props;

    const relationship = {
      create: ({ entityId, thickness }) => this.props.addMaterial(componentId, entityId, thickness),
      delete: id => this.props.removeMaterial(id),
      isCreating: this.props.isMaterialAdding,
      isDeleting: this.props.isMaterialRemoving,
    };
    return (
      <RelationDataTable
        columns={this.columns}
        data={materials}
        relationship={relationship}
        relationshipNameAccessor={item => item.material.name}
        classNamePrefix="select-material-component"
        filteredCount={filteredCount || materials.length}
        onActionEdit={material =>
          this.setState({
            isShowEditModal: true,
            selectedMaterial: material,
          })
        }
        onActionDelete={material =>
          this.setState({
            isShowDeleteModal: true,
            selectedMaterial: material,
          })
        }
        onFetchData={state => this.updateSortFilter(this.search.filtered, state, this.state.categoryOption)}
      />
    );
  }

  //// clear material data on redux 
  componentWillUnmount(){
    this.props.clearMaterialOpaqueOnRedux();
  }

  removeMaterialToComponentState(index){
    let materialArr =  [...this.state.materialToComponentArr];
    materialArr.splice(index,1);
    this.setState({materialToComponentArr:materialArr,isMaterialRemoving:true},()=>this.setState({isMaterialRemoving:false}))
  }

  createMaterialToComponentState(name, entityId,original) {
    const material = { id: entityId, name, is_public:original.is_public};
    if(this.state.materialToComponentArr.length<1){
      this.setState({
        materialToComponentArr: [
          ...this.state.materialToComponentArr,
          { material,material_id:entityId,thickness:toMilli(parseFloat(original.thickness))},
        ],errorMessage:null
      });
    }else {
      this.setState({errorMessage:"This Transparent Component already have material"})
    }
  }
  renderMaterialsWithoutComponentId() {
    const {
      component: { id: componentId },
      componentMaterials: materials,
      filteredCount,
    } = this.props;
    const relationship = {
      create: ({name, entityId,original }) => this.createMaterialToComponentState(name, entityId,original),
      delete: (index) => this.removeMaterialToComponentState(index),
      isCreating: this.props.isMaterialAdding,
      isDeleting: this.state.isMaterialRemoving,
    };

    return (
      <RelationDataTable
        columns={this.columns}
        data={this.state.materialToComponentArr}
        relationship={relationship}
        relationshipNameAccessor={item => item.material.name}
        classNamePrefix="select-material-component"
        filteredCount={filteredCount || (materials && materials.length) || 0}
        onActionEdit={material =>
          this.setState({
            isShowEditModal: true,
            selectedMaterial: material,
          })
        }
        onActionDelete={material =>
          this.setState({
            isShowDeleteModal: true,
            selectedMaterial: material,
          })
        }
        onFetchData={state => this.updateSortFilter(this.search.filtered, state, this.state.categoryOption)}
      />
    );
  }
  renderLayerPreview() {
    const { componentMaterials: materials, t } = this.props;
    const {materialToComponentArr} = this.state;
    const normMaterials = (materialToComponentArr.length>0?materialToComponentArr:materials).map(({id, material, thickness}) => ({id, name: material.name, thickness}));
    return (
      <MaterialLayerPreviewer materials={normMaterials} unit={t('unit_mm')}  />
    );
  }

  renderErrorMessage(errorMessage) {
    if (!errorMessage) return null;
    return (
      <Alert
        bsStyle="danger"
        style={{ 'white-space': 'pre' }}
      >
        {errorMessage}
      </Alert>
    );
  }

  render() {
    const { component, componentMaterials: materials, errorMessage, t } = this.props;
    const detailError = getErrorValue(errorMessage, 'detail');
    const onStateErrorMessage = this.state.errorMessage;
    if(this.props.materialsToComponent){
      this.props.materialsToComponent(this.state.materialToComponentArr);
    }
    return (
      <React.Fragment>
        
        {(onStateErrorMessage||detailError?this.renderErrorMessage(onStateErrorMessage||detailError) : null)}
        <Tabs defaultActiveKey={1} id="component-tabs">
          <Tab eventKey={1} title={t('basic info')}>
            {this.renderBasicInfo()}
          </Tab>
          {component.id
            ? (
            <Tab eventKey={2} title={t('materials')}>
              {this.renderMaterials()}
            </Tab>
          ) :    
            <Tab eventKey={2} title={t('materials')}>
              {this.renderMaterialsWithoutComponentId()}
            </Tab>}
          {materials ? (
            <Tab eventKey={3} title={t('preview')}>
              {this.renderLayerPreview()}
            </Tab>
          ) : null}
        </Tabs>
      </React.Fragment>
    );
  }
}

ComponentTransparentDetail.defaultProps = {
  component: {},
};

const mapStateToProps = state => ({
  componentMaterials: state.componentMaterial.orderedIds.map(id => {
    let cm = state.componentMaterial.objects[id];
    return {
      ...cm,
      thickness: toMilli(cm.thickness),
    }
  }),
  isLoading: state.componentMaterial.isLoading,
  filteredCount: state.componentMaterial.filteredCount,
  isMaterialAdding: state.componentMaterial.isCreating,
  isMaterialRemoving: state.componentMaterial.isDeleting,
  heatDissipationListLoading: state.reference.envelop.heatDissipationListLoading,
  heatDissipationList: state.reference.envelop.heatDissipationList,
  errorMessage: state.component.transparent.errorMessage || state.componentMaterial.errorMessage,
  materials : state.material.transparent.orderedIds.map(
    (id) => state.material.transparent.materials[id]
  ),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  listMaterial: (pageSize, page, sorted, filtered, isPublic) => dispatch(listMaterialInComponent(pageSize, page, sorted, filtered, isPublic, ownProps.component.id)),
  addMaterial: (componentId, materialId, thickness) =>
    dispatch(addMaterialToComponent(componentId, materialId, thickness)),
  removeMaterial: id => dispatch(removeMaterialFromComponent(id)),
  listHeatDissipation: () => dispatch(listHeatDissipation()),
  clearMaterialOpaqueOnRedux: ()=> dispatch(clearMaterialOpaque()),
});

export default translate('translations', { withRef: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { withRef: true },
  )(ComponentTransparentDetail)
);



// WEBPACK FOOTER //
// ./src/components/component_transparent/ComponentTransparentDetail.js